import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Tooltip } from "primereact/tooltip";

import "../index.css"

import { RadioButton } from "primereact/radiobutton";
import { updateSellerPIPunch } from "../../../services/api/sellerPIPunch";
import { raiseToast } from "../../../services/redux/reducers/toast/toast";

import { numberConversion, round } from "../../../utils";
import { getPMCompanyConfig } from "../../../setup/pmCompanyConfig";


const PaymentSummary = (props) => {
    const { sellerPO, sellerPOItems, sellerPIPunch, sellerPIPunchItems, sellerGRNQCPunch, paymentTerms, vendorPaymentReq, setVendorPaymentReq, vendorPayments, sellerPOPaymentDetails, getSellerPO } = props
    const { VPWiseSellerPOPaymentDetails } = sellerPOPaymentDetails

	const userDetails = useSelector(state => state.userDetails)

    const pmCompanyConfig = getPMCompanyConfig(userDetails.PMCompanyDetails.companyId)
    let { numberLocale } = pmCompanyConfig

    const dispatch = useDispatch()

    let rejectedOrShortQtyExists = false
    if(Math.abs(VPWiseSellerPOPaymentDetails?.sellerPOTotalPrice - sellerPO?.totalPOAmount) > 1){
        rejectedOrShortQtyExists = true
    }

    const handlePaymentOnHold = async (sellerPIPunchId, isOnHold) => {
        const updateObj = {
            isPaymentOnHold: false
        }

		let confirmMessage = "Confirm to unhold payment on PI"
		if(!isOnHold){
            updateObj.isPaymentOnHold = true
			confirmMessage = "Confirm to hold payment on PI"
		}

		if(!window.confirm(confirmMessage)){
			return
		}

		const updateResponse = await updateSellerPIPunch(sellerPIPunchId, updateObj)
		if(updateResponse.failure){
			return dispatch(raiseToast({severity:'error', detail: updateResponse.error, life: 3000}))
		} else {
            getSellerPO()
			dispatch(raiseToast({severity:'success', detail: "update successful", life: 3000}))
		}
	}

    const handlePaymentRequestChange = (documentName) => {
		let activeVendorPayments = vendorPayments.filter(eachVendorPayment => [9, 10, 12].includes(eachVendorPayment.statusId))
		let vendorPaymentExist = false 

		let selectedDocumentPaidTotally = false

		if(vendorPayments.length > 0){
			vendorPaymentExist = true
			vendorPayments.map(vp => ![6, 8, 11].includes(vp.statusId))
		}

		vendorPaymentReq.tdsAmount = 0
		vendorPaymentReq.paymentDate = new Date()
		delete vendorPaymentReq.minPaymentDate

		if(documentName === 'sellerpo'){
			let totalAdvanceAmount = 0
			let totalAdvanceRequestedAmount = 0
			let documentSelectedFlag = false

			let totalTDSAmount = 0
			let TDSVendorPaymentOnAdvance

			if(sellerPO.totalTDSAmount){ 
				totalTDSAmount = sellerPO.totalTDSAmount
			}
			
			activeVendorPayments.map(vp => {
				if(['ADV-PO', 'ADV-DEL'].includes(vp.paymentTerm)){
					totalAdvanceRequestedAmount += vp.amount
					if(vp.tdsAmount){
						totalAdvanceRequestedAmount += vp.tdsAmount
						TDSVendorPaymentOnAdvance = vp
					}
				}
			})

			let onlyAdvancePaymentExists = false 
			if(!sellerPOPaymentDetails.ondelivery_payment_amount && !sellerPOPaymentDetails.credit_payment_amount){
				onlyAdvancePaymentExists = true
			}

			if(paymentTerms.payAdvPOAmount){
                totalAdvanceAmount += paymentTerms.actualPayAdvPOAmount
                if(totalAdvanceRequestedAmount + 1 < totalAdvanceAmount){
                    vendorPaymentReq.paymentTerm = 'payAdvPO' 
					vendorPaymentReq.initialPaymentTerm = 'payAdvPO' 
                    vendorPaymentReq.selectedDocument = 'sellerpo'
                    vendorPaymentReq.totalAmount = sellerPO.totalPOAmount
                    vendorPaymentReq.amountRequested = totalAdvanceRequestedAmount
                    vendorPaymentReq.payableAmount = parseFloat(parseFloat(totalAdvanceAmount - totalAdvanceRequestedAmount).toFixed(2)) 
                    if(onlyAdvancePaymentExists && totalTDSAmount && !TDSVendorPaymentOnAdvance){
                        vendorPaymentReq.payableAmount = vendorPaymentReq.payableAmount - totalTDSAmount
                        vendorPaymentReq.tdsAmount = totalTDSAmount
                    }
                    documentSelectedFlag = true
                }
            }

            console.log("payableAmount", vendorPaymentReq.payableAmount, totalAdvanceAmount)
            
            if(paymentTerms.payAdvDeliveryAmount && !documentSelectedFlag){
                totalAdvanceAmount += paymentTerms.actualPayAdvDeliveryAmount
                console.log("entered advance ondev", totalAdvanceRequestedAmount + 1 < totalAdvanceAmount, totalAdvanceRequestedAmount, totalAdvanceAmount)
                if(totalAdvanceRequestedAmount + 1 < totalAdvanceAmount){
                    vendorPaymentReq.paymentTerm = 'payAdvDelivery' 
					vendorPaymentReq.initialPaymentTerm = 'payAdvDelivery' 
                    vendorPaymentReq.selectedDocument = 'sellerpo'
                    vendorPaymentReq.totalAmount = sellerPO.totalPOAmount
                    vendorPaymentReq.amountRequested = totalAdvanceRequestedAmount
                    vendorPaymentReq.payableAmount = parseFloat(parseFloat(totalAdvanceAmount - totalAdvanceRequestedAmount).toFixed(2))
                    if(onlyAdvancePaymentExists && totalTDSAmount && !TDSVendorPaymentOnAdvance && !paymentTerms.advance_po_payment_amount){
                        vendorPaymentReq.payableAmount = vendorPaymentReq.payableAmount - totalTDSAmount
                        vendorPaymentReq.tdsAmount = totalTDSAmount
                    }
                    documentSelectedFlag = true
                }
            }

            console.log("payableAmount", vendorPaymentReq.payableAmount)

            if(paymentTerms.payPDCDeliveryAmount && !documentSelectedFlag){
                totalAdvanceAmount += paymentTerms.actualPayPDCDeliveryAmount
                if(totalAdvanceRequestedAmount + 1 < totalAdvanceAmount){
                    vendorPaymentReq.paymentTerm = 'payPDCDelivery' 
					vendorPaymentReq.initialPaymentTerm = 'payPDCDelivery' 
                    vendorPaymentReq.selectedDocument = 'sellerpo'
                    vendorPaymentReq.totalAmount = sellerPO.totalPOAmount
                    vendorPaymentReq.amountRequested = totalAdvanceRequestedAmount
                    vendorPaymentReq.payableAmount = parseFloat(parseFloat(totalAdvanceAmount - totalAdvanceRequestedAmount).toFixed(2))
                    if(onlyAdvancePaymentExists && totalTDSAmount && !TDSVendorPaymentOnAdvance && !paymentTerms.advance_payment_amount){
                        vendorPaymentReq.payableAmount = vendorPaymentReq.payableAmount - totalTDSAmount
                        vendorPaymentReq.tdsAmount = totalTDSAmount
                    }
                    vendorPaymentReq.paymentDate = new Date().setDate(new Date().getDate() + paymentTerms.creditPeriod)
                    vendorPaymentReq.minPaymentDate = vendorPaymentReq.paymentDate
                    documentSelectedFlag = true
                }
            }

			if(totalAdvanceAmount <= totalAdvanceRequestedAmount){
				return
			}

		} else {
			sellerPOPaymentDetails.piPunchPaymentDetails.map(eachPiPaymentDetail => {
				if(eachPiPaymentDetail.sellerPIPunchId === documentName){
					
					let piRelatedVendorPayments = []
					let piOnDeliveryRequestedAmount = 0
					let piCreditRequestedAmount = 0
					let piTotalAmountRequested = 0

					let TDSAmount = 0
					let TDSVendorPayment

					let onDeliveryVendorPayments = []
					let creditVendorPayments = []

					let documentSelectedFlag = false

					if(eachPiPaymentDetail.piActualTDSAmount){ 
						TDSAmount = eachPiPaymentDetail.piActualTDSAmount
					}

					activeVendorPayments.map(vp => {
						if(vp.sellerPIPunchId && vp.sellerPIPunchId === eachPiPaymentDetail.sellerPIPunchId){
							piRelatedVendorPayments.push(vp)
							if(vp.paymentTerm === 'payOnDelivery'){
								piOnDeliveryRequestedAmount += vp.amount
								if(vp.tdsAmount){
									piOnDeliveryRequestedAmount += vp.tdsAmount
								}
								onDeliveryVendorPayments.push(vp)
							}
							if(vp.paymentTerm === 'payCredit'){
								piCreditRequestedAmount += vp.amount
								if(vp.tdsAmount){
									piCreditRequestedAmount += vp.tdsAmount
								}
								creditVendorPayments.push(vp)
							}
							if(vp.tdsAmount){
								TDSVendorPayment = vp
							}
						}
					})

					eachPiPaymentDetail.onDeliveryVendorPayments = onDeliveryVendorPayments 
					eachPiPaymentDetail.creditVendorPayments = creditVendorPayments

					console.log("onDeliveryVendorPayments", onDeliveryVendorPayments, creditVendorPayments)

					if(documentSelectedFlag){
						console.log("documentSelectedFlag", documentSelectedFlag, eachPiPaymentDetail)
						return
					}

					console.log("eachPiPaymentDetail", eachPiPaymentDetail)

					if(eachPiPaymentDetail.vpWisePayAdvPOAmount){
						piTotalAmountRequested += eachPiPaymentDetail.vpWisePayAdvPOAmount
					}
					if(eachPiPaymentDetail.vpWisePayAdvDeliveryAmount){
						piTotalAmountRequested += eachPiPaymentDetail.vpWisePayAdvDeliveryAmount
					}
					if(eachPiPaymentDetail.vpWisePayPDCDeliveryAmount){
						piTotalAmountRequested += eachPiPaymentDetail.vpWisePayPDCDeliveryAmount
					}

					if(eachPiPaymentDetail.vpWisePayOnDeliveryAmount && !eachPiPaymentDetail.isPaymentOnHold && !eachPiPaymentDetail.nonReceivedNonShortQtyExists && !eachPiPaymentDetail.onHoldQuantityExists){
						if(Math.abs(eachPiPaymentDetail.piTotalAmount - eachPiPaymentDetail.piActualTotalAmount) >= 0){
							let vpWisePayCreditAmount = 0 
							if(eachPiPaymentDetail.vpWisePayCreditAmount){
								vpWisePayCreditAmount = eachPiPaymentDetail.vpWisePayCreditAmount
							}
							let actualAdvancePaymentPlusOnDelivery = parseFloat(parseFloat(eachPiPaymentDetail.piActualTotalAmount - vpWisePayCreditAmount).toFixed(2))
							
							if(piTotalAmountRequested + piOnDeliveryRequestedAmount + 1 < actualAdvancePaymentPlusOnDelivery){
								vendorPaymentReq.paymentTerm = 'payOnDelivery' 
								vendorPaymentReq.initialPaymentTerm = 'payOnDelivery' 
								vendorPaymentReq.selectedDocument = eachPiPaymentDetail.sellerPIPunchId
								vendorPaymentReq.totalAmount = eachPiPaymentDetail.piActualTotalAmount
								vendorPaymentReq.amountRequested = parseFloat(piTotalAmountRequested.toFixed(2))
								
								vendorPaymentReq.payableAmount = parseFloat(parseFloat(actualAdvancePaymentPlusOnDelivery - piTotalAmountRequested - piOnDeliveryRequestedAmount).toFixed(2))
								
								if(TDSAmount && !TDSVendorPayment && vendorPaymentReq.payableAmount - TDSAmount > 0){
									vendorPaymentReq.payableAmount = parseFloat(parseFloat(vendorPaymentReq.payableAmount - TDSAmount).toFixed(2))
									vendorPaymentReq.tdsAmount = TDSAmount
								}
								documentSelectedFlag = true
							} else {
								piTotalAmountRequested += eachPiPaymentDetail.vpWisePayOnDeliveryAmount
							}
						} else {
							piTotalAmountRequested += eachPiPaymentDetail.vpWisePayOnDeliveryAmount
						}
					}

					if(eachPiPaymentDetail.vpWisePayCreditAmount && !documentSelectedFlag && !eachPiPaymentDetail.isPaymentOnHold && !eachPiPaymentDetail.nonReceivedNonShortQtyExists && !eachPiPaymentDetail.onHoldQuantityExists){
						if(Math.abs(eachPiPaymentDetail.piTotalAmount - eachPiPaymentDetail.piActualTotalAmount) >= 0){
							if(piTotalAmountRequested + piCreditRequestedAmount + 1 < eachPiPaymentDetail.piActualTotalAmount){
								console.log("entered 2", piTotalAmountRequested, piCreditRequestedAmount, eachPiPaymentDetail.piActualTotalAmount)
								vendorPaymentReq.paymentTerm = 'payCredit' 
								vendorPaymentReq.initialPaymentTerm = 'payCredit' 
								vendorPaymentReq.selectedDocument = eachPiPaymentDetail.sellerPIPunchId
								vendorPaymentReq.totalAmount = eachPiPaymentDetail.piActualTotalAmount
								vendorPaymentReq.amountRequested = parseFloat(piTotalAmountRequested.toFixed(2))
								vendorPaymentReq.payableAmount = parseFloat(parseFloat(eachPiPaymentDetail.piActualTotalAmount - piTotalAmountRequested - piCreditRequestedAmount).toFixed(2))
								if(TDSAmount && !TDSVendorPayment){
									vendorPaymentReq.payableAmount = parseFloat(parseFloat(vendorPaymentReq.payableAmount - TDSAmount).toFixed(2))
									vendorPaymentReq.tdsAmount = TDSAmount
								}
								
								if(paymentTerms.payCredit){
									let creditPeriod = paymentTerms.creditPeriod
									let relatedPurchaseInvoice = sellerPIPunch.find(eachSellerPIPunch => eachSellerPIPunch.sellerPIPunchId === eachPiPaymentDetail.sellerPIPunchId) //{}//bulkposeller.piPunchCount.find(obj => obj.piPunchNo === eachPiPaymentDetail.piPunchNo)
									
									let relatedGRNQCs = sellerGRNQCPunch.filter(eachSellerGRNQCPunch => eachSellerGRNQCPunch.sellerPIPunchId === relatedPurchaseInvoice.sellerPIPunchId)
									let firstRelatedGRNQC = null

									if(relatedGRNQCs.length > 0){
										firstRelatedGRNQC = relatedGRNQCs[0]
									}
									if(!firstRelatedGRNQC.processedDate){
										dispatch(raiseToast({severity:'error', detail: `Product received date not found on pipunch no : ${eachPiPaymentDetail.piPunchNo}`, life: 3000}))
									}
									let piPunchDate = new Date(firstRelatedGRNQC.processedDate).getTime()

									if(piPunchDate){
										vendorPaymentReq.paymentDate = new Date(new Date(piPunchDate).setDate(new Date(piPunchDate).getDate() + creditPeriod))
										vendorPaymentReq.minPaymentDate = vendorPaymentReq.paymentDate
									}
								}
								documentSelectedFlag = true
							}
						} 
					}

                    if(documentSelectedFlag == false){
						selectedDocumentPaidTotally = true
					}
				}
			})
		}

		if(selectedDocumentPaidTotally){
			return
		}

		if(sellerPOPaymentDetails.isCashPaymentExists){
			vendorPaymentReq.paymentMode = 'CASH'
		} else if(vendorPaymentReq.paymentTerm === 'payPDCDelivery'){
			vendorPaymentReq.paymentMode = 'CHEQUE'
		} else if(vendorPaymentReq.paymentTerm === 'payCredit'){
			vendorPaymentReq.paymentMode = 'CREDIT'
		} else {
			vendorPaymentReq.paymentMode = 'BANK TRANSFER'
		}

		setVendorPaymentReq({...vendorPaymentReq})
	}

	const renderPIPunchToolTip = (PIPunchPaymentDetail) => {
		return (
			<Tooltip target={`.tool-tip-pi-debitnote-${PIPunchPaymentDetail.sellerPIPunchId}`} position="top" autoHide >
				<div className="" style={{width: "200px"}}>
					<div className='flex' style={{margin: '0px'}}>
						<div className='col-6' style={{fontWeight: 'bold', textAlign: "center"}}>Debit Note No</div>
						{/*<div className='col-4' style={{fontWeight: 'bold', textAlign: "center"}}>Qty</div>*/}
						<div className='col-6' style={{fontWeight: 'bold', textAlign: "center"}}>Amount</div>
					</div>
					{
						PIPunchPaymentDetail.sellerDebitNotes.map(eachSellerDebitNote => {
							const relatedSellerDebitNoteItems = PIPunchPaymentDetail.sellerDebitNoteItems.filter(eachSellerDebitNoteItem => eachSellerDebitNoteItem.adjustmentNoteId === eachSellerDebitNote.adjustmentNoteId)

							let debitNoteAmount = 0
							relatedSellerDebitNoteItems.map(eachDebitNoteItem => {
								const relatedSellerPIPunchItem = sellerPIPunchItems.find(eachSellerPIPunchItem => eachSellerPIPunchItem.sellerPIPunchItemId === eachDebitNoteItem.sellerPIPunchItemId)
								const relatedSellerPOItem = sellerPOItems.find(eachSellerPOItem => eachSellerPOItem.sellerPOItemId === relatedSellerPIPunchItem.sellerPOItemId)
								
								let debitNoteItemBeforeTax = round(eachDebitNoteItem.adjustedQty * eachDebitNoteItem.adjustedPricePerUnit, 2)
								let debitNoteItemTax = 0 
								if(relatedSellerPOItem?.GSTRate){
									debitNoteItemTax = debitNoteItemBeforeTax * relatedSellerPOItem?.GSTRate / 100
								}
								debitNoteAmount += round(debitNoteItemBeforeTax + debitNoteItemTax, 2)
							})
							return (
								<div className='flex' style={{margin: '0px'}}>
									<div className='col-6' style={{textAlign: "center"}}>{eachSellerDebitNote.docNo}</div>
									{/*<div className='col-4' style={{textAlign: "center"}}>{PIPunchPaymentDetail.piDebitNoteQty}</div>*/}
									<div className='col-6' style={{textAlign: "center"}}>{debitNoteAmount}</div>
								</div>
							)
						})
					}
				</div>
			</Tooltip>
		)
	}

    return (
        <div className="p-card payment-summary-p-card payment-summary-table-container">
            <table className="custom-table mb-0 payment-summary-table">
                <thead style={{ fontSize: "12px" }}>
                    <tr className="custom-table-tr custom-tr">
                        <th className="custom-th"></th>
                        <th className="custom-th">Advance Against PO</th>
                        <th className="custom-th">Advance before Delivery</th>
                        <th className="custom-th">PDC on Delivery</th>
                        <th className="custom-th">On Delivery</th>
                        <th className="custom-th">Credit</th>
						<th className="custom-th">Debit Note</th>
                        <th className="custom-th">Total</th>
                    </tr>
                </thead>
                <tbody>
                    <tr style={{ background: vendorPaymentReq.selectedDocument === "sellerpo" && "#c8d8da57" }}>
                        <td className="custom-td text-left">
                            <RadioButton checked={vendorPaymentReq.selectedDocument === "sellerpo"} onChange={() => handlePaymentRequestChange("sellerpo")} />
                            <label htmlFor="" className="ml-2 text-sm text-500"><b>Seller PO</b></label>
                        </td>
                        <td className="custom-td">
                            <div className="tooltip"> {paymentTerms?.payAdvPOAmount ? `${paymentTerms.payAdvPOAmount} (${paymentTerms.payAdvPO}% ${sellerPOPaymentDetails.lastPaymentTerm === "payAdvPO" ? "+ tax" : ""})` : "-"}
                            </div>
                        </td>
                        <td className="custom-td">
                            <div className="tooltip"> {paymentTerms?.payAdvDeliveryAmount ? `${numberConversion(paymentTerms.payAdvDeliveryAmount, numberLocale)} (${paymentTerms.payAdvDelivery}% ${sellerPOPaymentDetails.lastPaymentTerm === "payAdvDelivery" ? "+ tax" : ""})` : "-"}
                            </div>
                        </td>
                        <td className="custom-td">
                            <div className="tooltip"> {paymentTerms?.payPDCDeliveryAmount ? `${numberConversion(paymentTerms.payPDCDeliveryAmount, numberLocale)} (${paymentTerms.payPDCDelivery}% ${sellerPOPaymentDetails.lastPaymentTerm === "payPDCDelivery" ? "+ tax" : ""})` : "-"}
                            </div>
                        </td>
                        <td className="custom-td">
                            <div className="tooltip"> {paymentTerms?.payOnDeliveryAmount ? `${numberConversion(paymentTerms.payOnDeliveryAmount, numberLocale)} (${paymentTerms.payOnDelivery}% ${sellerPOPaymentDetails.lastPaymentTerm === "payOnDelivery" ? "+ tax" : ""})` : "-"}
                            </div>
                        </td>
                        <td className="custom-td">
                            <div className="tooltip"> {paymentTerms?.payCreditAmount ? `${numberConversion(paymentTerms.payCreditAmount, numberLocale)} (${paymentTerms.payCredit}% ${sellerPOPaymentDetails.lastPaymentTerm === "payCredit" ? "+ tax" : ""})` : "-"}
                            </div>
                        </td>
						<td className="custom-td">
                            <div className="tooltip"> - </div>
                        </td>
                        <td className="custom-td">
                            {numberConversion(sellerPO?.totalPOAmount, numberLocale)}
                            { VPWiseSellerPOPaymentDetails?.sellerPOTotalPrice && rejectedOrShortQtyExists ? <p style={{margin: "3px", fontWeight: "bold"}}>{numberConversion(VPWiseSellerPOPaymentDetails.sellerPOTotalPrice, numberLocale)}</p> : ""}
                        </td>
                    </tr>

                    {
                        sellerPOPaymentDetails?.piPunchPaymentDetails?.map(eachPIPunchPaymentDetail => {
                            return (
                                <tr style={{ background: vendorPaymentReq.selectedDocument === eachPIPunchPaymentDetail.sellerPIPunchId && "#c8d8da57" }}>
                                    <td className="custom-td text-left">
                                        <RadioButton checked={vendorPaymentReq.selectedDocument === eachPIPunchPaymentDetail.sellerPIPunchId} onChange={() => handlePaymentRequestChange(eachPIPunchPaymentDetail.sellerPIPunchId)} />
                                        <label htmlFor="" className="ml-2 text-sm text-500"><b>{eachPIPunchPaymentDetail.sellerPINumber}</b></label>
                                        {/*<div><a style={{ color: "#9E9E9E", marginLeft: '30px', cursor: 'pointer', marginTop: '10px', fontSize: '12px' }} onClick={() => handlePaymentOnHold(eachPIPunchPaymentDetail.sellerPIPunchId, eachPIPunchPaymentDetail.isPaymentOnHold)} > { eachPIPunchPaymentDetail.isPaymentOnHold ? "Unhold Payment" : "Hold Payment" }</a></div>*/}
                                    </td>
                                    <td className="custom-td">
                                        <div className=""> 
                                            {eachPIPunchPaymentDetail?.payAdvPOAmount ? `${numberConversion(eachPIPunchPaymentDetail.payAdvPOAmount, numberLocale)}` : "-"}
                                            { eachPIPunchPaymentDetail.vpWisePayAdvPOAmount && rejectedOrShortQtyExists ? <p style={{margin: "3px", fontWeight: "bold"}}>{numberConversion(eachPIPunchPaymentDetail.vpWisePayAdvPOAmount, numberLocale)}</p> : ""}
                                        </div>
                                    </td>
                                    <td className="custom-td">
                                        <div className=""> 
                                            {eachPIPunchPaymentDetail?.payAdvDeliveryAmount ? `${numberConversion(eachPIPunchPaymentDetail.payAdvDeliveryAmount, numberLocale)}` : "-"}
                                            { eachPIPunchPaymentDetail.vpWisePayAdvDeliveryAmount && rejectedOrShortQtyExists ? <p style={{margin: "3px", fontWeight: "bold"}}>{numberConversion(eachPIPunchPaymentDetail.vpWisePayAdvPOAmount, numberLocale)}</p> : ""}
                                        </div>
                                    </td>
                                    <td className="custom-td">
                                        <div className=""> 
                                            {eachPIPunchPaymentDetail?.payPDCDeliveryAmount ? `${numberConversion(eachPIPunchPaymentDetail.payPDCDeliveryAmount, numberLocale)}` : "-"}
                                            { eachPIPunchPaymentDetail.vpWisePayPDCDeliveryAmount && rejectedOrShortQtyExists ? <p style={{margin: "3px", fontWeight: "bold"}}>{numberConversion(eachPIPunchPaymentDetail.vpWisePayAdvPOAmount, numberLocale)}</p> : ""}
                                        </div>
                                    </td>
                                    <td className="custom-td">
                                        <div className=""> 
                                            {eachPIPunchPaymentDetail?.payOnDeliveryAmount ? `${numberConversion(eachPIPunchPaymentDetail.payOnDeliveryAmount, numberLocale)}` : "-"}
                                            { eachPIPunchPaymentDetail.vpWisePayOnDeliveryAmount && rejectedOrShortQtyExists ? <p style={{margin: "3px", fontWeight: "bold"}}>{numberConversion(eachPIPunchPaymentDetail.vpWisePayAdvPOAmount, numberLocale)}</p> : ""}
                                        </div>
                                    </td>
                                    <td className="custom-td">
                                        <div className=""> 
                                            {eachPIPunchPaymentDetail?.payCreditAmount ? `${numberConversion(eachPIPunchPaymentDetail.payCreditAmount, numberLocale)}` : "-"}
                                            { eachPIPunchPaymentDetail.vpWisePayCreditAmount && rejectedOrShortQtyExists ? <p style={{margin: "3px", fontWeight: "bold"}}>{numberConversion(eachPIPunchPaymentDetail.vpWisePayAdvPOAmount, numberLocale)}</p> : ""}
                                        </div>
                                    </td>
									<td className="custom-td">
										<div className={`tool-tip-pi-debitnote-${eachPIPunchPaymentDetail.sellerPIPunchId}`}> {eachPIPunchPaymentDetail.piDebitNoteAmount || "-"} </div>
										{eachPIPunchPaymentDetail.piDebitNoteAmount > 0 && renderPIPunchToolTip(eachPIPunchPaymentDetail)}
									</td>
                                    <td className="custom-td">
                                        {numberConversion(eachPIPunchPaymentDetail?.piTotalAmount, numberLocale)}
                                        { eachPIPunchPaymentDetail.piActualTotalAmount && rejectedOrShortQtyExists ? <p style={{margin: "3px", fontWeight: "bold"}}>{numberConversion(eachPIPunchPaymentDetail.piActualTotalAmount, numberLocale)}</p> : ""}
                                    </td>
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
        </div>
    )
}

export default PaymentSummary;